import { createSelector } from 'reselect';

import type { State } from 'reducers';

export const selectAutoSourcingRulesState = (state: State) =>
  state.get('entities').autoSourcingRule;

export const selectAutoSourcingRules = createSelector(
  selectAutoSourcingRulesState,
  (autoSourcingRules) => autoSourcingRules
);

export const selectFirstAutoSourcingRule = createSelector(
  selectAutoSourcingRules,
  (autoSourcingRules) => autoSourcingRules.first()
);
